import { render, staticRenderFns } from "./OrganizerDealer.vue?vue&type=template&id=e60c18ea&"
import script from "./OrganizerDealer.vue?vue&type=script&lang=js&"
export * from "./OrganizerDealer.vue?vue&type=script&lang=js&"
import style0 from "./OrganizerDealer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports